import { Building2, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

// Reusable empty state for pages that require society setup first.
export const NeedsSetup = ({
  title = "Set up your society first",
  message = "Create your society profile to unlock this feature."
}) => {
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto py-16 text-center" data-testid="needs-setup">
      <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <Building2 className="w-8 h-8 text-emerald-700" />
      </div>
      <h2 className="text-xl font-semibold text-slate-900 mb-2" style={{ fontFamily: "Manrope" }}>{title}</h2>
      <p className="text-slate-600 mb-6">{message}</p>
      <Button onClick={() => navigate("/setup")} className="bg-emerald-700 hover:bg-emerald-800" data-testid="needs-setup-cta">
        Set Up My Society <ArrowRight className="w-4 h-4 ml-2" />
      </Button>
    </div>
  );
};
